module.exports = __webpack_public_path__ + "static/media/download-main-img.73a5e858.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/download-main-img.png
// module id = 582
// module chunks = 0